import React from "react";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { BRAND, STATS, TIMELINE } from "../data/content";

export const About = () => {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative py-24 sm:py-32 lg:py-40 bg-[#050505]"
    >
      <div
        className="spotlight"
        style={{
          width: 600,
          height: 600,
          background: "rgba(245,158,11,0.08)",
          top: "10%",
          left: "-200px",
        }}
      />

      <div className="max-w-[1400px] mx-auto px-6 sm:px-10 grid lg:grid-cols-12 gap-12 lg:gap-16">
        <motion.div
          initial={{ opacity: 0, x: -40 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
          className="lg:col-span-5 relative"
        >
          <div className="relative aspect-[3/4] overflow-hidden rounded-2xl border border-white/10">
            <div
              className="absolute inset-0 transition-all duration-1000"
              style={{
                backgroundImage: `url(${BRAND.portrait})`,
                backgroundSize: "auto 180%",
                backgroundPosition: "78% 28%",
                backgroundRepeat: "no-repeat",
                filter: "grayscale(55%) sepia(12%) brightness(0.92) contrast(1.05)",
              }}
              aria-label="it's Malie portrait"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
          className="lg:col-span-7"
        >
          <div className="flex items-center gap-4 mb-5">
            <span className="h-px w-10 bg-[color:var(--gold)]" />
            <span className="overline">The Story</span>
          </div>
          <h2 className="font-condensed text-5xl sm:text-6xl lg:text-7xl leading-[0.95]">
            An artist
            <br />
            <span className="font-display italic text-white/90">rooted in </span>
            <span className="gold-text">purpose.</span>
          </h2>

          <div className="mt-8 space-y-5 text-white/70 text-base sm:text-lg leading-relaxed max-w-2xl">
            <p>
              From the streets of Paterson, New Jersey to Norfolk, Virginia, Malie has built a sound rooted in resilience, purpose, and truth — a soulful resonance that continues to echo through every space it touches.
            </p>
            <p>
              More than an artist, he is a community leader whose work reflects the realities of the people around him. This music stands as a tribute to the trials and triumphs that shape everyday life, weaving together struggle, growth, loyalty, and hope through unfiltered storytelling. Every record feels lived-in and intentional, capturing the heartbeat of a community while inspiring the next generation to rise beyond their circumstances.
            </p>
          </div>

          <div className="mt-10">
            <a
              href="#contact"
              data-testid="about-read-full-story"
              className="inline-flex items-center gap-3 group"
            >
              <span className="overline">Read Full Story</span>
              <span className="w-12 h-12 rounded-full border border-white/20 grid place-items-center transition-all group-hover:border-[color:var(--gold)] group-hover:text-[color:var(--gold)] group-hover:translate-x-1">
                <ArrowRight size={16} />
              </span>
            </a>
          </div>
        </motion.div>
      </div>
    </section>
  );
};
